import BpkButton, {
  BUTTON_TYPES,
} from '@skyscanner-internal/backpack-web/bpk-component-button';
import {
  withButtonAlignment,
  withRtlSupport,
} from '@skyscanner-internal/backpack-web/bpk-component-icon';
import ArrowIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/long-arrow-right';

import './ProductLink.scss';

const AlignedArrowIcon = withButtonAlignment(withRtlSupport(ArrowIcon));

type ProductLinkProps = {
  label: string;
  href?: string;
  onClick?: () => void;
};

const ProductLink = ({ href, label, onClick }: ProductLinkProps) => (
  <div className="product-link">
    <BpkButton
      type={BUTTON_TYPES.link}
      href={href}
      onClick={onClick}
      {...(href ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
    >
      {label}
      <span className="product-link__icon" aria-hidden="true">
        <AlignedArrowIcon />
      </span>
    </BpkButton>
  </div>
);

export default ProductLink;
